module.exports = __webpack_public_path__ + "img/category_main_4.442e08bf.jpg";